import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import TaskPayFields, { type TaskPayValue } from '../../../shared/TaskPayFields';

interface TaskCardPaySectionProps {
    idPrefix: string;
    editing: boolean;
    canEdit: boolean;
    saving: boolean;
    value: TaskPayValue;
    amountLabel: string;
    visibleToExecutor: boolean;
    onChange: (value: TaskPayValue) => void;
    onStartEdit: () => void;
    onCancel: () => void;
    onSave: () => void;
}

const TaskCardPaySection = ({
    idPrefix,
    editing,
    canEdit,
    saving,
    value,
    amountLabel,
    visibleToExecutor,
    onChange,
    onStartEdit,
    onCancel,
    onSave,
}: TaskCardPaySectionProps) => {
    const { t } = useTranslation(['Tasks', 'common']);

    return (
        <section className="task-card-section mb-3">
            <div className="task-card-panel task-card-panel--compact">
                {canEdit && editing ? (
                    <>
                        <TaskPayFields idPrefix={idPrefix} value={value} onChange={onChange} />
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                type="button"
                                className="btn btn-link btn-sm p-0"
                                disabled={saving}
                                onClick={onCancel}
                            >
                                {t('common:buttons.cancel')}
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                disabled={saving}
                                onClick={onSave}
                            >
                                {t('common:buttons.save')}
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center gap-2 min-w-0">
                            <SolarIcon name="wallet2" className="fs-18 text-muted flex-shrink-0" />
                            <div className="min-w-0">
                                <div className="text-muted fs-12">{t('labelPayment')}</div>
                                <div className="text-body">{amountLabel}</div>
                                {canEdit && visibleToExecutor && (
                                    <div className="text-muted fs-12 d-flex align-items-center gap-1 mt-1">
                                        <SolarIcon name="eye" className="fs-14 flex-shrink-0" />
                                        <span>{t('labelPayVisibleToExecutor')}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            {canEdit && (
                                <button
                                    type="button"
                                    className="btn btn-link p-0 align-baseline fs-12"
                                    onClick={onStartEdit}
                                >
                                    <SolarIcon name="pencil" className="me-1 fs-14" />
                                    {t('btnEdit')}
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default TaskCardPaySection;
